// extracted by mini-css-extract-plugin
module.exports = {"tile":"HeroVariant4_tile__Wf9Ch","mediaContent":"HeroVariant4_mediaContent__pebdq","alignRight":"HeroVariant4_alignRight__A0qBY"};